import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo hoy mismo, sin esperas ni trámites.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'Está diseñado para docentes de nivel técnico secundario y terciario que dictan Bromatología, Tecnología Alimentaria, Microbiología de Alimentos, Higiene y Seguridad Alimentaria, o materias afines en escuelas técnicas, institutos y formación profesional.'
}, {
  q: '¿Sirve para cualquier país de América Latina hispanohablante?',
  a: 'Sí. El material cubre la normativa vigente de Argentina, Chile, Colombia, México, Perú, Ecuador, Bolivia, Paraguay, Uruguay, Costa Rica, Guatemala, Honduras, El Salvador, Nicaragua, Panamá y República Dominicana. Cada sección incluye referencias a las regulaciones específicas de cada país.'
}, {
  q: '¿El material es editable?',
  a: 'El Mega Pack se entrega en formato PDF listo para usar. Podés proyectarlo, imprimirlo o compartirlo con tus alumnos tal como está — sin necesidad de adaptarlo.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Puedes pagar en tu moneda local. El sistema detecta automáticamente tu país y convierte el importe.'
}, {
  q: '¿Qué incluye el Pack Maestro Avanzado de 27,90?',
  a: 'Incluye todo el Mega Pack Bromatología en el Aula (4 tomos + 4 bonos) más el módulo completo de Toxicología Alimentaria: 8 módulos especializados con casos reales documentados en 16 países de América Latina.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días para revisarlo todo. Si no estás conforme, te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-82">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-white pr-8" data-id="element-86">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}